import { IInfluencerCards } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { Platform } from 'react-native';
import FastImage from 'react-native-fast-image';
import { getConfig } from '../../config';
import { getInfluencerAvatarURL } from '../../utils/avatar-helpers';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import WorkoutSectionCardWithImageContentWrapper from './WorkoutSectionCardWithImageContentWrapper';
import { workoutSliderCardStyle } from './WorkoutSlider';

interface IProps {
  onlyOneCardInSlider: boolean;
  lastCardInSlider: boolean;
  tileData: IInfluencerCards;
  navigation: any;
  t: (key: string, options?: any) => string;
}

export const InfluencerScheduleSliderCard: FunctionComponent<IProps> = (
  {
    onlyOneCardInSlider,
    lastCardInSlider,
    tileData,
    navigation,
    t,
  },
) => {
  const PTGroupImageHeight = 643;
  const PTGroupImageWidth = 643;
  const { influencerName, influencerId } = tileData;
  const influencerImageUrl = getInfluencerAvatarURL(influencerId);
  return (
    <HorizontalScrollerCard
      style={workoutSliderCardStyle.container}
      onPress={()=> {
        if (Platform.OS === 'web') {
          window.location.href = `${getConfig().webAppBaseUrl}/influencer?influencerId=${influencerId}`;
        } else {
          navigation.navigate('InfluencerContainer', {influencerId});
        }
      }}
      wideCard={onlyOneCardInSlider}
      lastCard={lastCardInSlider}
    >
      <WorkoutSectionCardWithImageContentWrapper
        imageHeight={PTGroupImageHeight}
        imageWidth={PTGroupImageWidth}
        header={t('workoutWithInfluencer', {influencerName})}
        subHeading={t('viewSchedule')}
        image={{uri: influencerImageUrl, cache: FastImage.cacheControl.web}}
        applyBottomGradient={false}
        applyHorizontalGradient={false}
        applyImageGradient={true}
      />
    </HorizontalScrollerCard>
  );
};
